import { AvailityElementValue } from "risa-data-model";
import { CheckBox, DateInput, Select, TextInput } from "risa-oasis-ui_v2";
import { KeyLabelElementObject } from "../../../utils/procedurePaFromConstants";
import { ElementType } from "../element-type";
import AddInfoComponent from "./add-info-component/addInfoComponent";
import CustomHeading from "./custom-heading/customHeading";

export const renderElement = (
  sectionRefs,
  item: KeyLabelElementObject,
  handleChange,
  onDeleteClick,
  handleCheckboxChanges,
  addAdditionalComponent,
) => {
  const handleChangeWrapper = (value: any) => {
    handleChange(item.key, value);
  };

  const element = item.element;

  if (!element) return null;

  let renderedElement;
  switch (element.type) {
    case ElementType.Text:
    case ElementType.Collection:
      renderedElement = (
        <TextInput
          key={item.key}
          defaultValue={element?.filledValue || ""}
          onChange={(e) => handleChangeWrapper(e.value)}
          id={item.key}
          label={element.label}
          required={element.required || false}
          //TODO: Will figure out how to handle this error
          // error={
          //   checkFieldValidation(element?.required, item.key, element)
          //     ? element.errorMessage
          //     : ""
          // }
        />
      );
      break;
    case ElementType.Date:
      renderedElement = (
        <DateInput
          key={item.key}
          value={element?.filledValue?.split("T")[0] || ""}
          defaultValue={element?.filledValue?.split("T")[0] || ""}
          onChange={(e) => handleChangeWrapper(e.value + "T05:00:00.000+00:00")}
          id={item.key}
          label={element.label}
          required={element.required || false}
          //TODO: Will figure out how to handle this error
          // error={
          //   checkFieldValidation(element?.required, item.key, element)
          //     ? element.errorMessage
          //     : ""
          // }
        />
      );
      break;
    case ElementType.Enumeration:
      const options = (element.values as AvailityElementValue[]).map(
        (value: AvailityElementValue) => ({
          value: value.code?.toString() || "",
          label: value.value?.toString() || "",
        }),
      );
      renderedElement = (
        <Select
          key={item.key}
          id={item.key}
          label={element.label}
          placeholder={`Select ${element.label}`}
          options={options}
          onOptionChange={(data) => handleChangeWrapper(data.value)}
          value={element?.filledValue || ""}
          defaultValue={element?.filledValue || ""}
          required={element.required || false}
          //TODO: Will figure out how to handle this error
          // error={
          //   checkFieldValidation(element.required, item.key, element)
          //     ? element.errorMessage
          //     : ""
          // }
        />
      );
      break;
    case ElementType.Heading:
      const actionText = item.key.includes("_") ? "Delete" : "";
      renderedElement = (
        <div className="heading-element" key={item.key}>
          <CustomHeading
            heading={element.label}
            actionText={actionText}
            id={item.key}
            onActionClick={(id) => onDeleteClick(id)}
          />
        </div>
      );
      break;
    case ElementType.Checkbox:
      renderedElement = (
        <div className="heading-element" key={item.key}>
          <CheckBox
            label={element.label}
            id={item.key}
            onCheckBoxValueChange={function (data: {
              name: string;
              value: boolean;
            }): void {
              handleCheckboxChanges(data.name, data.value);
            }}
          />
        </div>
      );
      break;
    case ElementType.AddButton:
      renderedElement = (
        <div className="heading-element" key={item.key}>
          <AddInfoComponent
            title={element.label}
            onClick={() => {
              addAdditionalComponent(item.key);
            }}
          />
        </div>
      );
      break;
    default:
      renderedElement = null;
  }

  return (
    <div
      ref={(el) => (sectionRefs.current[item.key] = el)}
      key={item.key}
      id={item.key}
      className={
        element.type === ElementType.Heading ||
        element.type === ElementType.Checkbox ||
        element.type === ElementType.AddButton
          ? "heading-element-wrapper"
          : ""
      }
    >
      {renderedElement}
    </div>
  );
};
